import React from 'react';

const ApplicationSuccess = ({ application, onNewApplication }) => {
  const handlePrint = () => window.print();

  return (
    <div className="tl-success-page">
      <div className="success-card" id="application-receipt">
        <div className="success-icon">✓</div>
        <h2>Application Submitted Successfully</h2>
        <p className="success-subtitle">
          Your trade license application has been received. Please save your application number for future reference.
        </p>

        <div className="success-number-box">
          <span className="success-label">Application Number</span>
          <span className="success-number">{application.application_number}</span>
        </div>

        <dl className="success-details">
          <dt>Applicant</dt>
          <dd>{application.applicant_first_name_en || application.applicant_name}</dd>
          <dt>Business Name</dt>
          <dd>{application.business_name_en}</dd>
          <dt>Application Type</dt>
          <dd>{(application.application_type || 'new_license').replace(/_/g, ' ')}</dd>
          <dt>Submitted On</dt>
          <dd>{new Date().toLocaleString()}</dd>
          <dt>Status</dt>
          <dd><span className="status-badge submitted">Submitted</span></dd>
        </dl>

        <div className="success-note">
          <p>You can track your application status using the <strong>Check Status</strong> tab with your application number and registered mobile number.</p>
        </div>
      </div>

      <div className="success-actions no-print">
        <button type="button" className="btn btn-primary" onClick={handlePrint}>
          🖨️ Print Acknowledgement
        </button>
        {onNewApplication && (
          <button type="button" className="btn btn-secondary" onClick={onNewApplication}>
            Submit Another Application
          </button>
        )}
      </div>
    </div>
  );
};

export default ApplicationSuccess;
